var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('a-descriptions',{staticClass:"p-0",attrs:{"title":"Management Scope","column":1,"size":"small"}},_vm._l((_vm.groupedScopes),function(scope){return _c('a-descriptions-item',{key:scope.type,attrs:{"label":scope.label}},[_vm._v(" "+_vm._s(scope.value)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }